import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CommunityShowcase = () => {
  const [activeProject, setActiveProject] = useState(0);
  const [liveMetrics, setLiveMetrics] = useState({
    activeUsers: 1247,
    projectsCompleted: 8934,
    mentoringSessions: 456
  });

  const domains = [
    { name: "Robotics", icon: "Cpu" },
    { name: "Python", icon: "Code" },
    { name: "Data Science", icon: "BarChart" },
    { name: "Computer Vision", icon: "Camera" },
    { name: "AI / ML", icon: "Brain" },
    { name: "Gen AI", icon: "Sparkles" },
    { name: "Research Projects", icon: "BookOpen" },
    { name: "Competitions", icon: "Trophy" }
  ];

  const featuredProjects = [
    {
      id: 1,
      title: "AI-Powered Human Pose System",
      creator: "Chirag Sharma",
      avatar: "/assets/images/avatars/chirag_logo.jpeg",
      image: "/assets/images/project_images/pose_detection.png",
      description: "Real-time tracking of human movements using computer vision.",
      tech: ["OpenCV", "Mediapipe", "Python"],
      category: "AI/ML",
      status: "In Development"
    },
    {
      id: 2,
      title: "Classroom Mapping System",
      creator: "Neel Mehta",
      avatar: "/assets/images/avatars/neel_logo.jpeg",
      image: "/assets/images/project_images/classroom_mapping.png",
      description: "AI-powered tool to craft job-winning resumes.",
      tech: ["HTML", "CSS", "JavaScript", "SQL", "PHP"],
      category: "Web Development",
      status: "Developed"
    },
    {
      id: 3,
      title: "Generative AI Quiz Maker",
      creator: "Likhit Desai",
      avatar: "/assets/images/avatars/likhit_logo.jpeg",
      image: "/assets/images/project_images/quiz_maker.png",
      description: "Auto-generate quizzes in seconds using Generative AI",
      tech: ["Gemini API", "Python", "Streamlit"],
      category: "Gen AI",
      status: "In Development"
    }
  ];

  const memberSpotlights = [
    {
      id: 1,
      name: "Neel Mehta",
      role: "IT Student at MPSTME",
      avatar: "/assets/images/avatars/neel_logo.jpeg",
      achievement: "Teaching Python to 50+ students, Mentored 4 teams to Victory in WSRO 2025",
      timeframe: "Pursuing B.Tech in Information Technology",
      quote: "DCC was the perfect platform to kickstart my coding journey"
    },
    {
      id: 2,
      name: "Likhit Desai",
      role: "Mechanical Student at MPSTME",
      avatar: "/assets/images/avatars/likhit_logo.jpeg",
      achievement: "Mentored VEX IQ Team to International in May, 2025",
      timeframe: "Pursuing B.Tech in Mechanical Engineering",
      quote: "The hands-on robotics training was exactly what I needed."
    },
    {
      id: 3,
      name: "Soham Shah",
      role: "Extension Developer - Kodular",
      avatar: "/assets/images/avatars/soham_logo.jpeg",
      achievement: "Handling all Kodular Extensions",
      timeframe: "Pursuing B.Tech in Computer Science",
      quote: "The entrepreneurship mentorship was invaluable."
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveProject((prev) => (prev + 1) % featuredProjects.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const metricsInterval = setInterval(() => {
      setLiveMetrics(prev => ({
        activeUsers: prev.activeUsers + Math.floor(Math.random() * 3),
        projectsCompleted: prev.projectsCompleted + Math.floor(Math.random() * 2),
        mentoringSessions: prev.mentoringSessions + Math.floor(Math.random() * 2)
      }));
    }, 5000);

    return () => clearInterval(metricsInterval);
  }, []);

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Explore <span className="gradient-text">Cutting-Edge</span> Domains
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Discover groundbreaking projects, connect with fellow innovators, and see the real impact of our community-driven learning approach.
          </p>
        </div>

        {/* Live Metrics */}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="holographic-card p-6 text-center">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <div className="w-3 h-3 bg-success rounded-full animate-pulse"></div>
              <span className="text-sm text-muted-foreground">Live Now</span>
            </div>
            <div className="text-3xl font-bold text-foreground mb-1">{liveMetrics.activeUsers.toLocaleString()}</div>
            <div className="text-sm text-muted-foreground">Active Learners</div>
          </div>

          <div className="holographic-card p-6 text-center">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Icon name="CheckCircle" size={12} className="text-success" />
              <span className="text-sm text-muted-foreground">Completed</span>
            </div>
            <div className="text-3xl font-bold text-foreground mb-1">{liveMetrics.projectsCompleted.toLocaleString()}</div>
            <div className="text-sm text-muted-foreground">Projects Built</div>
          </div>

          <div className="holographic-card p-6 text-center">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Icon name="Users" size={12} className="text-accent" />
              <span className="text-sm text-muted-foreground">This Week</span>
            </div>
            <div className="text-3xl font-bold text-foreground mb-1">{liveMetrics.mentoringSessions.toLocaleString()}</div>
            <div className="text-sm text-muted-foreground">Mentoring Sessions</div>
          </div>
        </div> */}

        {/* Domains Section */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 mb-16">
          {domains.map((domain, index) => (
            <div key={index} className="holographic-card p-6 text-center hover:shadow-lg transition">
              <div className="flex items-center justify-center mb-3">
                <Icon name={domain.icon} size={24} className="text-accent" />
              </div>
              <div className="text-lg font-semibold text-foreground">{domain.name}</div>
            </div>
          ))}
        </div>

        {/* Featured Projects */}
        <div className="mb-20">
          <div className="flex items-center justify-between mb-8">
            <h3 className="text-2xl font-bold text-foreground">Featured Projects</h3>
            <div className="flex space-x-2">
              {featuredProjects.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveProject(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === activeProject
                      ? 'bg-accent shadow-glow'
                      : 'bg-muted hover:bg-muted-foreground'
                  }`}
                  aria-label={`View project ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="relative">
              <div className="holographic-card overflow-hidden">
                <Image
                  src={featuredProjects[activeProject].image}
                  alt={featuredProjects[activeProject].title}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute top-4 right-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    featuredProjects[activeProject].status === 'Live Demo Available' ?'bg-success/20 text-success'
                      : featuredProjects[activeProject].status === 'Deployed' ?'bg-accent/20 text-accent' :'bg-warning/20 text-warning'
                  }`}>
                    {featuredProjects[activeProject].status}
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <div className="flex items-center space-x-3 mb-3">
                  <Image
                    src={featuredProjects[activeProject].avatar}
                    alt={featuredProjects[activeProject].creator}
                    className="w-20 h-20 rounded-full"
                  />
                  <div>
                    <div className="font-large text-xl">{featuredProjects[activeProject].creator}</div>
                    <div className="text-sm text-muted-foreground">{featuredProjects[activeProject].category}</div>
                  </div>
                </div>
                
                <h4 className="text-xl font-bold text-foreground mb-3">
                  {featuredProjects[activeProject].title}
                </h4>
                
                <p className="text-muted-foreground mb-4">
                  {featuredProjects[activeProject].description}
                </p>
              </div>

              <div>
                <div className="flex flex-wrap gap-2 mb-4">
                  {featuredProjects[activeProject].tech.map((tech) => (
                    <span
                      key={tech}
                      className="px-3 py-1 bg-muted rounded-full text-xs font-medium text-muted-foreground"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                {/* <div className="flex items-center space-x-6 mb-6">
                  <div className="flex items-center space-x-2">
                    <Icon name="Heart" size={16} className="text-error" />
                    <span className="text-sm text-muted-foreground">{featuredProjects[activeProject].likes}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Icon name="MessageCircle" size={16} className="text-accent" />
                    <span className="text-sm text-muted-foreground">{featuredProjects[activeProject].comments}</span>
                  </div>
                </div> */}

                {/* <div className="flex space-x-3">
                  <Button
                    variant="default"
                    size="sm"
                    className="morphing-cta text-white"
                    iconName="ExternalLink"
                    iconPosition="right"
                  >
                    View Project
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Code"
                    iconPosition="left"
                  >
                    Source Code
                  </Button>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Member Spotlights */}
        <div>
          <h3 className="text-2xl font-bold text-foreground mb-8 text-center">Member Success Stories</h3>
          
          <div className="grid md:grid-cols-3 gap-6">
            {memberSpotlights.map((member) => (
              <div key={member.id} className="holographic-card p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <Image
                    src={member.avatar}
                    alt={member.name}
                    className="w-12 h-12 rounded-full"
                  />
                  <div>
                    <div className="font-semibold text-foreground">{member.name}</div>
                    <div className="text-sm text-accent">{member.role}</div>
                  </div>
                </div>
                
                <div className="mb-4">
                  <div className="text-sm font-medium text-foreground mb-1">{member.achievement}</div>
                  <div className="text-xs text-muted-foreground">{member.timeframe}</div>
                </div>
                
                <blockquote className="text-sm text-muted-foreground italic">
                  "{member.quote}"
                </blockquote>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <Link to="/contact-support">
            <Button
              variant="default"
              size="lg"
              className="morphing-cta text-white font-semibold px-8 py-4"
              iconName="Users"
              iconPosition="left"
            >
              Join Our Community
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CommunityShowcase;